export default {
  sections: {
    alcohol_percentage: 'Zawartość alkoholu: {{value}}%',
    price_per_unit: 'Cena za {{unit}}: {{value}}',
    gtin: 'GTIN',
    ingredients: 'Składniki',
    allergens: 'Alergeny',
    additives: 'Dodatki',
    nutrition_breakdown: {
      title: 'Informacje odżywcze',
      description: '100 {{unit}} zawiera:',
      items: {
        energy: 'Energia',
        fat: 'Tłuszcz',
        saturates: 'w tym nasycone kwasy tłuszczowe',
        carbohydrates: 'Węglowodany',
        sugars: 'w tym cukry',
        protein: 'Białko',
        salt: 'Sól',
      },
    },
  },
  units: {
    l: 'litr',
    kg: 'kilo',
    default: 'jednostka',
  },
};
